import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import LiveChat from "./components/feature/LiveChat";
import CookieBanner from "./components/feature/CookieBanner";
import { AdminProvider } from "./contexts/AdminContext";
import PageTitleHandler from "./components/feature/PageTitleHandler";
import ScrollToTop from "./components/base/ScrollToTop";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AdminProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <ScrollToTop />
          <PageTitleHandler />
          <AppRoutes />
          <LiveChat />
          <CookieBanner />
        </BrowserRouter>
      </AdminProvider>
    </I18nextProvider>
  );
}

export default App;
